var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRouters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 75,
    viewBox: "0 0 82 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.884 47.0928H5.68976C3.49919 47.0928 1.72339 48.8686 1.72339 51.0591V69.4591C1.72339 71.6497 3.49919 73.4255 5.68976 73.4255H76.884C79.0746 73.4255 80.8504 71.6497 80.8504 69.4591V51.0591C80.8504 48.8686 79.0746 47.0928 76.884 47.0928Z",
    stroke: "#352890",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9592 61.3402C11.4732 61.3402 11.8899 60.9235 11.8899 60.4095C11.8899 59.8955 11.4732 59.4788 10.9592 59.4788C10.4451 59.4788 10.0284 59.8955 10.0284 60.4095C10.0284 60.9235 10.4451 61.3402 10.9592 61.3402Z",
    stroke: "#352890",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1879 61.3402C17.702 61.3402 18.1187 60.9235 18.1187 60.4095C18.1187 59.8955 17.702 59.4788 17.1879 59.4788C16.6739 59.4788 16.2572 59.8955 16.2572 60.4095C16.2572 60.9235 16.6739 61.3402 17.1879 61.3402Z",
    stroke: "#352890",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4024 61.3402C23.9164 61.3402 24.3331 60.9235 24.3331 60.4095C24.3331 59.8955 23.9164 59.4788 23.4024 59.4788C22.8883 59.4788 22.4716 59.8955 22.4716 60.4095C22.4716 60.9235 22.8883 61.3402 23.4024 61.3402Z",
    stroke: "#352890",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6169 61.3402C30.1309 61.3402 30.5476 60.9235 30.5476 60.4095C30.5476 59.8955 30.1309 59.4788 29.6169 59.4788C29.1029 59.4788 28.6862 59.8955 28.6862 60.4095C28.6862 60.9235 29.1029 61.3402 29.6169 61.3402Z",
    stroke: "#352890",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2854 54.581C71.7994 54.581 72.2161 54.1643 72.2161 53.6502C72.2161 53.1362 71.7994 52.7195 71.2854 52.7195C70.7713 52.7195 70.3546 53.1362 70.3546 53.6502C70.3546 54.1643 70.7713 54.581 71.2854 54.581Z",
    stroke: "#352890",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.672 60.4089H53.0286",
    stroke: "#352890",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4716 1.04248C36.4756 1.04248 47.8163 12.3975 47.8163 26.3872",
    stroke: "#352890",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2164 9.34741C32.1658 9.34741 39.4255 16.6072 39.4255 25.5566",
    stroke: "#352890",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9751 17.6526C27.8842 17.6526 31.0487 20.8171 31.0487 24.7262",
    stroke: "#352890",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1187 47.0926V30.683L24.2043 24.5974",
    stroke: "#352890",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouters);
export default __webpack_public_path__ + "static/media/Routers.3f8f1aa3e958ce73fd539d8d567c5dfa.svg";
export { ForwardRef as ReactComponent };